import { render, staticRenderFns } from "./introducePageSex.vue?vue&type=template&id=95082220&scoped=true"
import script from "./introducePageSex.vue?vue&type=script&lang=js"
export * from "./introducePageSex.vue?vue&type=script&lang=js"
import style0 from "./introducePageSex.vue?vue&type=style&index=0&id=95082220&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95082220",
  null
  
)

export default component.exports